<script setup>
import {inject} from "vue";
import SecuredBadge from "./SecuredBadge.vue";

const shareLink = inject('shareLink');

const {fileList} = defineProps(['fileList']);

const shareUrl = function (href) {
  let url = new URL(href,window.location.origin);
  shareLink(url.toString());
};


</script>

<template>
  <div v-for="camera_card in fileList.channels.camera_cards" class="list-group-item list-group-item-action overflow-x-hidden px-lg-4 px-sm-1 py-2" >
      <a :href="camera_card.url" target="_blank" class="icon-link col-11 col-lg-12 col-md-11 col-sm-6">
          <i class="icon bi me-lg-3 me-sm-1 project"></i>
          {{camera_card.project_name}}
      </a>
    <a href="#" @click.prevent="shareUrl(camera_card.url)" class="btn btn-outline-light btn-share end-0 top-50 translate-middle-y position-absolute">
      <i class="icon share">
        <SecuredBadge class="position-relative, secured" />
      </i>
    </a>
  </div>
</template>
